export default {
  paper: {
    maxWidth: 360,
  },
};
